export const commonMessages = {
  success: "success",
  error: "error",
  uploadImg: "upload-img",
  warning: "warning",
};